import { render, staticRenderFns } from "./M_wrapConfig.vue?vue&type=template&id=6c557571&scoped=true&"
import script from "./M_wrapConfig.vue?vue&type=script&lang=js&"
export * from "./M_wrapConfig.vue?vue&type=script&lang=js&"
import style0 from "./M_wrapConfig.vue?vue&type=style&index=0&id=6c557571&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c557571",
  null
  
)

export default component.exports